// extracted by mini-css-extract-plugin
module.exports = {"header":"Common_style_header__2JvPE"};